import { supabase } from '../lib/supabase';

export type AccessState = 'approved' | 'pending' | 'error';

/**
 * בדיקת אישור הגישה של המשתמש המחובר.
 * הלקח מ-IronBar: תשובה ריקה/שגיאה (רשת, RLS, שורה חסרה) היא 'error' —
 * לעולם לא מפרשים אותה כ"לא מאושר" ולא מקבלים עליה החלטה הרסנית.
 */
export async function checkAccess(): Promise<AccessState> {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session) return 'error';
    // פילטר user_id מפורש: לאדמין ה-RLS מחזיר את כל השורות, כך שבלי הפילטר
    // maybeSingle היה נכשל/לא-דטרמיניסטי. (הקריאה מ-getSession — מקומית.)
    const { data, error } = await supabase
      .from('litebite_users_access')
      .select('is_approved')
      .eq('user_id', session.user.id)
      .maybeSingle();
    if (error || !data) return 'error';
    return data.is_approved ? 'approved' : 'pending';
  } catch {
    return 'error';
  }
}

export async function isAdmin(): Promise<boolean> {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session) return false;
    const { data } = await supabase
      .from('litebite_users_access')
      .select('is_admin')
      .eq('user_id', session.user.id)
      .maybeSingle();
    return data?.is_admin === true;
  } catch {
    return false;
  }
}
